import { useLocation, useNavigate } from "react-router-dom"

import NavItems from "./NavItems"
import Notifications from "./Notifications"
import Breadcrumbs from "./Breadcrumbs"
import DashboardNav from "./DashboardNav"
import QuestionCircle from "../components/svg/QuestionCircle"
import NotificationDot from "../components/UI/NotificationDot"
import { FiChevronRight } from "react-icons/fi"
import { useQuery } from "react-query"
import jwtDecode from "jwt-decode"

import { api } from "../util/APIConfig"

function LayoutNav({ setActiveNav, profileImage }) {
  const location = useLocation()
  const navigate = useNavigate()
  const role = jwtDecode(localStorage.getItem("token")).role
  const isStudent = role === "Student"

  const { isSuccess, data } = useQuery(
    "hoursRemaining",
    async () => {
      const res = await api("/Tution/Tution/GetDashboardData", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      })
      return res.data.data.tutoringHoursRemaining
    },
    {
      enabled: isStudent
    }
  )

  const { isSuccess2, programName } = useQuery(
    "bookingLight",
    async () => {
      const res = await api("/crosscontextquery/CrossContextQuery/booking-light", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      })
      return res.data.data.programName
    },
    {
      enabled: isStudent
    }
  )

  const startImpersonation = async () => {
    try {
      const isParent = true;
      const data = await api.post('/authentication/admin/impersonation/startImpersonation', { isParent });
      if (data) {
        const decodedData = jwtDecode(data.data.data.accessToken)
        localStorage.setItem("token", data.data.data.accessToken)
        localStorage.setItem("refreshToken", data.data.data.refreshToken)
        localStorage.setItem("email", decodedData.email)

        window.location = '/'
      }
    } catch (error) {
      console.error('Error starting impersonation:', error);
    }
  };

  return (
    <nav
      className="container-in fixed top-0 z-50 flex h-[55px] w-full
     items-center justify-between bg-white py-2 lg:static lg:h-[90px] lg:py-6"
    >
      <div
        className="hamburger-nav"
        onClick={() => setActiveNav(prev => !prev)}
      >
        <img src="/assets/hamburger.svg" alt="Menu" />
      </div>
      <div className="flex gap-2">
        <Breadcrumbs className="hidden lg:flex" />
      </div>
      <div className="nav-right ml-auto flex items-center gap-4 xl:gap-11">
        {(location.pathname.includes("/") ||
          location.pathname.includes("/sales")) &&
        jwtDecode(localStorage.getItem("token")).role === "Admin" ? (
          <>
            {location.pathname === "/" && (
              <button
                className="shadow-3 flex items-center gap-3 rounded-lg bg-primary px-4 py-2 font-semibold text-white"
                onClick={() => navigate("/sales")}
              >
                <span>Booking Form</span> <FiChevronRight size={24} />
              </button>
            )}
            {location.pathname === "/audit-dashboard" && (
              <div className="flex gap-7">
                <NotificationDot color="#06D79E" title="<= 6 Days" />
                <NotificationDot color="#FA6E42" title="7-9 Days" />
                <NotificationDot color="#DA535C" title=">= 10 Days" />
              </div>
            )}
            {location.pathname === "/submissions" && (
              <div className="flex gap-7">
                <NotificationDot color="#06D79E" title="Marked" />
                <NotificationDot color="#FA6E42" title="Pending" />
                <NotificationDot color="#DA535C" title="Overdue" />
              </div>
            )}
          </>
        ) : (
          <>
            <DashboardNav className="flex" />
            {location.pathname === "/tuition" && isSuccess && isSuccess2 && (
              <div className={`flex items-baseline gap-1 text-darker-gray ${programName === 'Full Blue' || programName === 'Fellow' ? 'hidden' : ''}`}>
                <span className="heading-4l font-medium">{data}</span>
                <span className="body-3">Hours Left</span>
              </div>
            )}
            <div className="profile flex items-center gap-7">
              <Notifications />
              {role === "Student" && (
                <>
                  <button
                    className="max-w-[20px] cursor-pointer transition-all duration-300 hover:scale-110"
                    onClick={() => navigate("/help")}
                  >
                    <QuestionCircle height={27} width={22} fill="#888888" />
                  </button>
                  <div className="relative z-10 h-8 w-8 rounded-full filter lg:h-11 lg:w-11">
                    <NavItems profileImage={profileImage} />
                  </div>
                </>
              )}
            </div>
          </>
        )}
        {jwtDecode(localStorage.getItem("token")).role === "Parent" && (
          <button 
          onClick={() => startImpersonation()}
          className="shadow-3 flex items-center gap-3 rounded-lg border-2 border-primary px-4 py-2 font-semibold text-primary hover:bg-blue-500 hover:text-white">
            <svg
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.1099 0.950507C11.1099 0.45345 11.5128 0.0505066 12.0099 0.0505066H17C17.497 0.0505066 17.9 0.45345 17.9 0.950507V5.94061C17.9 6.43766 17.497 6.84061 17 6.84061C16.5029 6.84061 16.1 6.43766 16.1 5.94061V2.81635L7.65615 11.2602C7.30468 11.6116 6.73483 11.6116 6.38335 11.2602C6.03188 10.9087 6.03188 10.3388 6.38335 9.98737L14.5202 1.85051H12.0099C11.5128 1.85051 11.1099 1.44756 11.1099 0.950507ZM2.86136 3.44456C2.60639 3.44456 2.36185 3.54585 2.18156 3.72615C2.00126 3.90644 1.89998 4.15097 1.89998 4.40595V15.5743C1.89998 15.8292 2.00126 16.0738 2.18156 16.2541C2.36185 16.4344 2.60639 16.5357 2.86136 16.5357H14.0297C14.2847 16.5357 14.5292 16.4344 14.7095 16.2541C14.8898 16.0738 14.9911 15.8292 14.9911 15.5743V9.65919C14.9911 9.16214 15.394 8.75919 15.8911 8.75919C16.3881 8.75919 16.7911 9.16214 16.7911 9.65919V15.5743C16.7911 16.3066 16.5001 17.009 15.9823 17.5269C15.4644 18.0447 14.762 18.3357 14.0297 18.3357H2.86136C2.129 18.3357 1.42663 18.0447 0.908767 17.5269C0.390907 17.009 0.0999756 16.3066 0.0999756 15.5743V4.40595C0.0999756 3.67358 0.390907 2.97121 0.908767 2.45335C1.42663 1.93549 2.129 1.64456 2.86136 1.64456H8.00706C8.50412 1.64456 8.90706 2.04751 8.90706 2.54456C8.90706 3.04162 8.50412 3.44456 8.00706 3.44456H2.86136Z"
                fill="#485AFF"
              />
            </svg>

            <span>Student Portal</span>
          </button>
        )}
      </div>
    </nav>
  )
}

export default LayoutNav
